import type {IconTree} from '@ui/icons/create-svg-icon';

export interface MenuConfig {
  id: string;
  name: string;
  positions: string[];
  items: MenuItemConfig[];
}

interface MenuItemBase {
  id: string;
  order?: number;
  label: string;
  action: string;
  target?: '_blank' | '_self';
  roles?: number[];
  permissions?: string[];
  settings?: Record<string, any>;
  subscriptionStatus?: 'subscribed' | 'unsubscribed';
  icon?: IconTree[] | null;
}

export interface MenuLeafItemConfig extends MenuItemBase {
  type: 'route' | 'link';
}

export interface MenuDropdownItemConfig extends MenuItemBase {
  type: 'dropdown';
  action: string;
  items: MenuLeafItemConfig[];
}

export type MenuItemConfig = MenuLeafItemConfig | MenuDropdownItemConfig;

export function isDropdownMenuItem(
  item: MenuItemConfig,
): item is MenuDropdownItemConfig {
  return item.type === 'dropdown';
}
